import { ADD_IMAGE, CLEAR_IMAGES, LOADING_IMAGE, STOP_LOADING_IMAGE } from '../types'

export const addImage = (state) => {
  return {
    type: ADD_IMAGE,
    payload: state,
  }
}

export const setImages = (images) => (dispatch) => {
  dispatch({ type: LOADING_IMAGE })
  dispatch({ type: CLEAR_IMAGES })
  for (const image of images) {
    dispatch({
      type: ADD_IMAGE,
      payload: image,
    })
  }
  dispatch({ type: STOP_LOADING_IMAGE })
}
export const clearImages = () => {
  return {
    type: CLEAR_IMAGES,
  }
}
